import { render, staticRenderFns } from "./GenericView.vue?vue&type=template&id=9508b58e&scoped=true"
import script from "./GenericView.vue?vue&type=script&lang=js"
export * from "./GenericView.vue?vue&type=script&lang=js"
import style0 from "./GenericView.vue?vue&type=style&index=0&id=9508b58e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9508b58e",
  null
  
)

export default component.exports